import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.16 12.533H9.5a.5.5 0 0 1 0-1h10.79l-2.426-2.099a.526.526 0 0 1-.07-.721.476.476 0 0 1 .686-.067l3.337 2.887c.117.102.18.245.181.39a.531.531 0 0 1-.17.435l-3.259 2.988a.47.47 0 0 1-.683-.05.532.532 0 0 1 .054-.727l2.22-2.036zM3 21h14.5a.5.5 0 1 1 0 1h-15a.5.5 0 0 1-.5-.5v-19a.5.5 0 0 1 .5-.5h15a.5.5 0 1 1 0 1H3v18z"
});

var SvgLogout = function SvgLogout(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgLogout;